/* eslint import/prefer-default-export: "off" */

export { mandatory };

function mandatory(parameterName = '') {
  throw new ReferenceError(`Missing parameter ${parameterName}`);
}
